import React from 'react';

interface ChatIconProps {
    className?: string;
}

const ChatIcon: React.FC<ChatIconProps> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={className}
    >
        <path
            d="M5.33333 8.00033H5.34M8 8.00033H8.00667M10.6667 8.00033H10.6733M14 8.00033C14 10.9458 11.3137 13.3337 8 13.3337C6.97382 13.3337 6.00781 13.1047 5.16311 12.701L2 13.3337L2.92999 10.8537C2.34104 10.0286 2 9.04984 2 8.00033C2 5.05481 4.68629 2.66699 8 2.66699C11.3137 2.66699 14 5.05481 14 8.00033Z"
            stroke="#0E62F4"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ChatIcon;
